<template>
  <el-drawer
    :close-on-click-modal="true"
    :close-on-press-escape="false"
    :with-header="false"
    v-model="drawer"
    size="480"
    modal-class="member-user-drawer"
  >
    <div class="header">
      <div class="btn">
        <img
          class="close"
          @click="drawer = false"
          src="https://uploads.ytripos.com/close.png"
        />
      </div>
    </div>
    <div class="contact">
      <div class="contact-infoBox flex items-center mb-[24px]">
        <img
          class="w-[56px] h-[56px]"
          src="../CurrentUser/icon-head.png"
          alt=""
        />
        <div class="info ml-3">
          <div class="flex items-center member">
            {{ user?.name }}
            <img class="level ml-2" :src="memberLevel" alt="" />
          </div>
          <div class="email">{{ user?.email }}</div>
        </div>
      </div>
      <div class="shadow-box" />
      <div class="operation mt-[26px] mb-[64px]">
        <div
          v-for="(item, index) in displaySettingsList"
          :key="index"
          @click="handleClickSetting(item)"
        >
          <div
            :class="[
              'flex',
              'items-center',
              'justify-between',
              item.type !== 'one-level' ? 'mb-[40px]' : 'mb-[30px]'
            ]"
          >
            <div class="flex items-center">
              <img class="icon" :src="item.icon" alt="" />
              <span class="text">{{ t(item.label) }}</span>
            </div>
            <p class="right-triangle" v-if="item.type !== 'one-level'" />
          </div>
          <div v-for="(el, i) in item.child" :key="i">
            <div
              class="flex items-center justify-between ml-[32px] mb-[24px]"
              @click="handleClickSetting(el)"
              v-if="el.show"
            >
              <div class="flex items-center">
                <span class="second-text">{{ t(el.label) }}</span>
              </div>
              <p class="right-triangle" />
            </div>
          </div>
        </div>
      </div>
      <div class="logout" @click="handleClickSetting(logout)">
        {{ t(logout.label) }}
      </div>
    </div>
    <!-- <my-vouchers v-model:show="vouchers" /> -->
  </el-drawer>
</template>
<script setup>
import { get } from "lodash-es";
import { storeToRefs } from "pinia";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";

import { useYChannelStoreHook } from "@/distributions/consumer/y/store/channel";
import { useDeploymentStoreHook } from "@/store/modules/deployment";
import { useUserStoreHook } from "@/store/modules/user";

// import myVouchers from "./myVouchers.vue";

const drawer = defineModel("show");

const props = defineProps({
  settings: {
    type: Array,
    default: () => []
  }
});

const vouchers = ref(false);

const { t } = useI18n();
const router = useRouter();
const userStore = useUserStoreHook();
const yChannelStore = useYChannelStoreHook();
const deploymentStore = useDeploymentStoreHook();
const { user } = storeToRefs(userStore);
const displaySettingsList = computed(() => {
  const levelRefType = get(userStore.user, "loyaltyProgram.ref.type", "");
  const arr = [
    {
      label: "shared.auth.creditCard.promotions",
      path: "/credit-card-match",
      show:
        deploymentStore.isActive("HOTELUX_CREDIT_CARD_MATCH") &&
        (!levelRefType || levelRefType === "guest")
    },
    {
      label: "shared.contactInfo.airlineMatch.title",
      path: "/airline-match",
      show:
        deploymentStore.isActive("HOTELUX_AIR_LINE_MATCH") &&
        (!levelRefType || levelRefType === "guest")
    }
  ];
  const el = props.settings.filter(item => !arr.includes(item.path));
  const showOneLevel = arr.some(item => item.show);
  let list = el.filter(item => {
    if (item.show) {
      return item.show(user.value);
    }
    if (!item.label.includes("logout")) {
      return true;
    }

    return false;
  });
  // list.push({
  //   icon: "https://qiniu-uploads-cdn.charmdeer.com/icon_voucher.png",
  //   label: "shared.common.product.voucher",
  //   type: "not-close",
  //   onClick: () => {
  //     vouchers.value = true;
  //   }
  // });
  if (showOneLevel) {
    list.push({
      label: "shared.auth.upgradeMembership",
      type: "one-level"
    });
  }

  list = list.map(item => {
    if (item.type === "one-level") {
      item.child = arr;
      item.icon = "https://uploads.ytripos.com/member_icon.png";
    }
    if (item.path === "/orders") {
      item.icon = "https://uploads.ytripos.com/order_icon.png";
    }
    return item;
  });
  return list;
});

const memberLevel = computed(() => {
  return yChannelStore.configs?.level[
    user.value?.loyaltyProgram?.ref?.type || "guest"
  ];
});

const logout = computed(() => {
  return props.settings.filter(item => {
    if (item.label.includes("logout")) {
      return true;
    }
    return false;
  })[0];
});

const handleClickSetting = item => {
  if (item.type === "one-level") return;
  if (item.type !== "not-close") {
    drawer.value = false;
  }

  if (item.path) {
    router.push({
      path: item.path
    });
  }
  if (typeof item.onClick === "function") {
    item.onClick();
  }
};

watch(
  () => drawer.value,
  async val => {
    if (val) {
      await userStore.getUser();
    }
  }
);
</script>
<style lang="scss" scoped>
.member-user-drawer {
  .el-drawer {
    --el-drawer-padding-primary: 0px;
  }
  .icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
  }
  .header {
    padding: 20px 36px 20px 36px;
    .close {
      height: 16px;
      // font-size: 14px;
      // line-height: 14px;
      cursor: pointer;
    }
  }
  .contact {
    padding: 31px 36px 24px 36px;
    .member {
      font-family: var(--y-title-font);
      font-size: 20px;
      color: var(--y-text-color);
    }
    .level {
      height: 18px;
    }
    .shadow-box {
      width: 100%;
      height: 16px;
      background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0.04) 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
    .email {
      font-size: 12px;
      color: var(--y-description-text-color);
      font-family: var(--y-regular-font);
    }

    .right-triangle {
      width: 8px;
      height: 8px;
      background: url("https://uploads.ytripos.com/right_icon.png");
      background-size: cover;
      cursor: pointer;
    }
    .text {
      font-family: var(--y-regular-font);
      color: var(--y-text-color);
    }
    .second-text {
      color: var(--y-text-default-color);
      font-size: 14px;
      font-family: var(--y-regular-font);
    }
    .operation {
      cursor: pointer;
    }
    .logout {
      border: 1px solid #d8d8d8;
      padding: 17px 0;
      font-family: var(--y-medium-font);
      font-size: 14px;
      color: var(--y-text-color);
      text-align: center;
      margin-top: 24px;
      cursor: pointer;
      text-transform: uppercase;
    }
  }
}
</style>
